import {
  Table as ChakraTable,
  TableContainer,
  type TableContainerProps,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { flexRender, type Table } from '@tanstack/react-table';

import { styles } from './styles';

export { styles } from './styles';

export type TanstackTableProps<T> = TableContainerProps & {
  table: Table<T>;
  isLoading?: boolean;
};

export function TanstackTable<T>({
  table,
  isLoading = false,
  ...props
}: TanstackTableProps<T>) {
  return (
    <TableContainer
      width="100%"
      transition="opacity 100ms linear"
      opacity={isLoading ? 0.5 : 1}
      mb={4}
      {...props}
    >
      <ChakraTable
        width="100%"
        sx={{ ...styles, marginTop: '0' }}
        mb={0}
        size="sm"
      >
        <Thead>
          {table.getHeaderGroups().map((group) => (
            <Tr key={group.id}>
              {group.headers.map((header) => (
                <Th key={header.id}>
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext(),
                  )}
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody>
          {table.getRowModel().rows.map((row) => (
            <Tr key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <Td key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </Td>
              ))}
            </Tr>
          ))}
        </Tbody>
      </ChakraTable>
    </TableContainer>
  );
}
